export enum VideoAssignmentSubmissionStatus {
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface Topic {
  startTime: number;
  endTime: number;
  title: string;
  summary?: string;
}

export interface Analysis {
  recordingIssues: boolean;
  sideBySideCoverage: number;
  summary: string;
  topics: Topic[];
  recordingQuality?: string;
}

export interface Clip {
  ordinal: number | null;
  path: string;
  thumbnail?: string;
}

export interface Video {
  id: string;
  createDate: string;
  duration: number;
  failed: boolean;
  clips: Clip[];
  thumbnails?: string[];
  analysis?: Analysis;
  // TODO: DOUBLE CHECK THIS
  status?: VideoAssignmentSubmissionStatus;
}

export interface StatusHistory {
  event: string;
  videoId: string;
  createDate: string;
}

export interface VideoAssignmentSubmission {
  classId: number;
  createDate: string;
  id: string;
  assignmentId: string;
  objectType: string;
  status: VideoAssignmentSubmissionStatus;
  submittedVideoId: string | null;
  statusHistory: StatusHistory[];
  videos: Video[];
  userId: number;
  roomId: string | null;
  recordingStartedAt: number | null;
  recordingStoppedAt: number | null;
  submittedDate: string | null;
  assignedInstructorId?: number;
}

// FOR FE
export interface User {
  email?: string;
  name?: string;
}

export interface SubmissionWithUserAndInstructor extends VideoAssignmentSubmission {
  user?: User;
  instructor?: User;
}
